import {
  DESTINATION_PRESETS,
  FULLCLIP_PRESET,
  PLATFORM_DISPLAY_NAMES,
} from './constants';
import DestinationPlatforms from './DestinationPlatforms';
import DestinationPlatformsContents from './DestinationPlatformsContents';
import DestinationPlatformsHeader from './DestinationPlatformsHeader';
import DestinationPlatformsVideoTypes from './DestinationPlatformsVideoTypes';
import {
  checkIfDestinationPresetExists,
  decorateVideoTypesForAspectRatio,
  getAudiogramPlatformsConfig,
  getDisabledPlatformsForAspectRatio,
  getPlatformConfig,
  getPresetMaxDurationKey,
} from './utils';

export default DestinationPlatforms;
export {
  DestinationPlatformsVideoTypes,
  checkIfDestinationPresetExists,
  decorateVideoTypesForAspectRatio,
  DESTINATION_PRESETS,
  FULLCLIP_PRESET,
  getPresetMaxDurationKey,
  getDisabledPlatformsForAspectRatio,
  getPlatformConfig,
  DestinationPlatformsHeader,
  DestinationPlatformsContents,
  getAudiogramPlatformsConfig,
  PLATFORM_DISPLAY_NAMES,
};
export * from './types';
